import { useLogin } from '@bnnvara/accounts';
import { track } from '@bnnvara/analytics/src/track';
import { BaseButton } from '@bnnvara/buttons';
import PropTypes from 'prop-types';
import React from 'react';
import { useInView } from 'react-intersection-observer';

import resizeImageSource from '../../../helpers/resizeImageSource';
import Notification from '../../Notification';
import Header from '../Header';
import * as S from './styled';

const ProfileHeaderLoggedOut = ({ page }) => {
  const { isLoggedIn, login } = useLogin();
  const buttonText = isLoggedIn ? page.callToActionLoggedIn : page.callToAction;

  const [notificationProfileRef, inViewProfile] = useInView({
    threshold: 0.8,
  });
  const notification = (
    <S.NotificationContainer ref={notificationProfileRef}>
      <Notification
        visible={inViewProfile}
        type="bnnvaraProfileHeaderNotification"
        title="Nieuw: Profielpagina"
        closeText="Oké, Ik snap het"
        horizontalPosition="center"
        direction="up"
        delay={2000}
      >
        <p>
          De plek op BNNVARA.nl waar je jouw titels terug kan vinden. We werken
          aan meer mogelijkheden die je kunt gebruiken!
        </p>
      </Notification>
    </S.NotificationContainer>
  );

  const headerButton = (
    <BaseButton
      size="small"
      type="button"
      variant="red"
      onClick={() => {
        track('header', 'click', 'cta');
        login();
      }}
    >
      {buttonText}
    </BaseButton>
  );

  return (
    <Header
      backgroundImageUrl={page.backgroundImage}
      backgroundImageMobileUrl={page.backgroundImageMobile}
      title={page.title}
      subtitle={page.subtitle}
      description={page.description}
      descriptionNotification={notification}
      avatar={resizeImageSource(page.logoUrl, 120)}
      customCtaButton={headerButton}
    />
  );
};
ProfileHeaderLoggedOut.defaultProps = {
  page: {
    callToAction: null,
    callToActionLoggedIn: null,
    callToActionUrl: null,
  },
};
ProfileHeaderLoggedOut.propTypes = {
  page: PropTypes.shape({
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    backgroundImage: PropTypes.string.isRequired,
    backgroundImageMobile: PropTypes.string.isRequired,
    logoUrl: PropTypes.string.isRequired,
    callToAction: PropTypes.string,
    callToActionLoggedIn: PropTypes.string,
    callToActionUrl: PropTypes.string,
  }),
};

export default ProfileHeaderLoggedOut;
